(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8449],{

/***/ 4498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[categoryHandle]",
      function () {
        return __webpack_require__(7262);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ProductCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_common_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9257);
/* harmony import */ var _product_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8717);



// import { ProductCategoryTags } from './product-category-tags'

var ProductCard = function(props) {
    var data = props.data, categoryHandle = props.categoryHandle;
    // console.log('ProductCard props', props)
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative grid grid-cols-1 gap-x-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_product_image__WEBPACK_IMPORTED_MODULE_3__/* .ProductImage */ .q, {
                    productData: data,
                    categoryHandle: categoryHandle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/shop/".concat(categoryHandle, "/").concat(data.slug),
                    className: "flex h-full w-full justify-between rounded-b-lg p-4 font-bold text-colorFourteen",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "w-[50%] text-lg text-colorFourteen",
                            children: data.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: "justify-self-end",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRight */ .ol, {
                                fill: "rgb(203, 153, 114)"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
ProductCard.displayName = "ProductCard";


/***/ }),

/***/ 8717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ProductImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4522);




function RenderSpecialProductCondition(param) {
    var _onSale = param.onSale, onSale = _onSale === void 0 ? false : _onSale, _isNew = param.isNew, isNew = _isNew === void 0 ? false : _isNew;
    if (onSale && isNew) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute top-7 -left-4 z-10 flex h-16 w-16 items-center justify-center rounded-full bg-colorTen px-2 py-1 font-tucker-tub text-xl font-bold text-colorFifteen",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute top-[31%]",
                        children: "New"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute top-16 -left-4 z-10 flex h-16 w-16 items-center justify-center rounded-full bg-colorThirteen px-2 py-1 font-tucker-tub text-xl font-bold text-colorFifteen",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute top-[31%]",
                        children: "Sale"
                    })
                })
            ]
        });
    }
    if (onSale) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute top-7 -left-4 z-10 flex h-16 w-16 items-center justify-center rounded-full bg-colorThirteen px-2 py-1 font-tucker-tub text-xl font-bold text-colorFifteen",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute top-[31%]",
                children: "Sale"
            })
        });
    }
    if (isNew) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute top-10 -left-4 z-10 flex h-16 w-16 items-center justify-center rounded-full bg-colorTen px-2 py-1 font-tucker-tub text-xl font-bold text-colorFifteen",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute top-[31%]",
                children: "New"
            })
        });
    }
    return null;
}
var ProductImage = function(props) {
    var ref, ref1;
    var productData = props.productData, isSinglePage = props.isSinglePage, categoryHandle = props.categoryHandle;
    // console.log('ProductImage props', props)
    var PRODUCT_NEW_TIMER = 30 * 24 * 60 * 60 * 1000 // 30 days
    ;
    var dateCreated = new Date(productData.date_created);
    var isProductNew = new Date().getTime() - dateCreated.getTime() < PRODUCT_NEW_TIMER;
    var ref2;
    var imageWrapperComponent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui__WEBPACK_IMPORTED_MODULE_3__/* .ImageWrapper */ .fb, {
        className: "group",
        children: [
            !productData.purchasable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute left-4 top-4 z-10 rounded-[50px] border border-white bg-black py-2 px-3 text-white",
                children: "SOLD OUT"
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderSpecialProductCondition, {
                onSale: productData.on_sale,
                isNew: isProductNew
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                className: "h-full w-full rounded-[10px] bg-white object-contain ".concat(productData.images.length > 1 && "visible absolute opacity-100 transition-all duration-700 group-hover:invisible group-hover:opacity-0"),
                src: (ref2 = (ref = productData.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src) !== null && ref2 !== void 0 ? ref2 : "/assets/images/product-image-placeholder.svg",
                sizes: "(min-width: 75em) 33vw, (min-width: 48em) 50vw, 100vw",
                width: 615,
                height: 615,
                alt: productData.name,
                priority: true
            }),
            productData.images.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                className: "invisible absolute h-full w-full rounded-[10px] object-cover opacity-0 transition-all duration-700 group-hover:visible group-hover:opacity-100",
                src: productData.images[1].src,
                sizes: "(min-width: 75em) 33vw, (min-width: 48em) 50vw, 100vw",
                width: 615,
                height: 615,
                alt: productData.name,
                priority: true
            })
        ]
    });
    if (isSinglePage) {
        return imageWrapperComponent;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/shop/".concat(categoryHandle, "/").concat(productData.slug),
        children: imageWrapperComponent
    });
};


/***/ }),

/***/ 7262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Category; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _components_commerce_product_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(206);
/* harmony import */ var _components_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(108);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4522);





var __N_SSG = true;
function Category(param) {
    var category = param.category;
    console.log("category category", category);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "Shop | ".concat(category.name, " | Tucker Tub"),
                description: "Shop Category Description",
                openGraph: {
                    title: "Shop | ".concat(category.name, " | Tucker Tub"),
                    description: "Shop Category Description",
                    url: "https://preview.tuckertub.com.au",
                    type: "website",
                    locale: "en_AU",
                    site_name: "Tucker Tub"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common__WEBPACK_IMPORTED_MODULE_3__/* .Layout */ .Ar, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-colorFifteen",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mx-auto px-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common__WEBPACK_IMPORTED_MODULE_3__/* .Breadcrumbs */ .Oo, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Wrapper */ .im, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid grid-cols-1 gap-8 pt-4 pb-10 text-colorFourteen sm:grid-cols-[2fr_4fr]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "p-0 font-tucker-tub text-header uppercase",
                                            children: category.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "p-0",
                                            children: category.description
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            className: "mx-auto px-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3",
                                    children: category.products.map(function(product) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_commerce_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductCard */ .I, {
                                            data: product,
                                            categoryHandle: category.slug
                                        }, product.id);
                                    })
                                })
                            }, category.id)
                        })
                    ]
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4507,236,5812,8969,9774,2888,179], function() { return __webpack_exec__(4498); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);